export default __webpack_public_path__ + "static/media/Roger_Compton_bw.eab758ce.jpg";